import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";

/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-13 17:07:31
 * @FilePath: \heshan_web\src\util\utils.js
 */
export var uuid = function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";

  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }

  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010

  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
};
export var compare = function compare(propertyName) {
  return function (object1, object2) {
    var value1 = object1[propertyName];
    var value2 = object2[propertyName];

    if (value2 < value1) {
      return -1;
    } else if (value2 > value1) {
      return 1;
    } else {
      return 0;
    }
  };
};
export var stringify = function stringify(json) {
  var count = 0;
  var list = [];
  var str = JSON.stringify(json, function (key, val) {
    if (typeof val === 'function') {
      list.push(val + '');
      var result = '$code{' + count + '}$code';
      count = count + 1;
      return result;
    }

    return val;
  }, 2);
  var startCode = '$code{';
  var endCode = '}$code';
  list.forEach(function (ele, index) {
    str = str.replace(startCode + index + endCode, startCode + ele + endCode);
  });

  for (var i = 0; i < count; i++) {
    str = str.replace('"' + startCode, '').replace(endCode + '"', '');
  }

  return str;
};
export var parse = function parse(str) {
  return JSON.parse(str, function (k, v) {
    if (v.indexOf && v.indexOf('function') > -1) {
      return eval("(function(){return " + v + " })()");
    }

    return v;
  });
};
export var addUrlParam = function addUrlParam(url, param, value) {
  if (!url) return;

  function GetQueryString(name) {
    var num = url.indexOf("?");
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = url.substr(num + 1).match(reg);

    if (r != null) {
      return unescape(r[2]);
    }

    return null;
  }

  function replaceParamVal(paramName, value) {
    var re = eval('/(' + paramName + '=)([^&]*)/gi');
    return url.replace(re, paramName + '=' + value);
  }

  if (GetQueryString(param)) {
    return replaceParamVal(param, value);
  } else {
    if (url.includes('?')) {
      url = url + '&' + param + '=' + value;
    } else {
      url = url + '?' + param + '=' + value;
    }

    return url;
  }
};
export var downBlob = function downBlob(res) {
  var blob = new Blob([res.data], {
    type: 'application/actet-stream;charset=utf-8'
  });
  var contentDisposition = res.headers['content-disposition']; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;

  var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
  var result = patt.exec(contentDisposition);
  var filename = decodeURIComponent(result[1]);
  var downloadElement = document.createElement('a');
  var href = window.URL.createObjectURL(blob); //创建下载的链接

  downloadElement.style.display = 'none';
  downloadElement.href = href;
  downloadElement.download = filename; //下载后文件名

  document.body.appendChild(downloadElement);
  downloadElement.click(); //点击下载

  document.body.removeChild(downloadElement); //下载完成移除元素

  window.URL.revokeObjectURL(href); //释放掉blob对象
};